<script lang="ts">
  import { TextInput } from "carbon-components-svelte";
  import type { ICanvas } from "src/ts/Interfaces";
  import Colour from "../../steps/Colour.svelte";
  import Border from "../../steps/Border.svelte";
  import FileUpload from "./../../../components/common/FileUpload.svelte";
  import Spacing from "../../steps/Spacing.svelte";
  import type APIClient from "src/ts/APIClient";

  export let canvas: ICanvas;
  export let client: APIClient;
  let uploadedFileIds: string[] = [];
  let allowImageUpload: boolean = false;
</script>

{#if canvas.lines}
  <TextInput
    labelText="Text"
    placeholder="Enter text for this line"
    bind:value={canvas.lines[0].content}
  />
  {#if allowImageUpload}
    <FileUpload
      canvasWidth={canvas.canvasWidth}
      canvasHeight={canvas.canvasHeight}
      bind:uploadedFileIds
      {client}
    />
  {/if}
{/if}

<Colour
  hidden={canvas.hideColors || canvas.stampType === "Traditional"}
  bind:selected={canvas.colors[0]}
/>

<Border hidden={canvas.hideBorder} bind:border={canvas.border} />

<Spacing hidden={!canvas.hideSpacing} bind:spacing={canvas.spacing} />
